import styled from 'styled-components';

export const Container = styled.div`
  max-width: 90%;
  margin: auto;
  border: 1px solid #4b286d;
  padding: 3rem;
  border-radius: 1rem;
`;

export const FieldOptionsGroup = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  row-gap: 0.5rem;

  @media only screen and (max-width: 1300px) {
    grid-template-columns: repeat(2, 1fr);
  }

  @media only screen and (max-width: 780px) {
    grid-template-columns: 1fr;
  }
`;

export const UploadButton = styled.button`
  margin-top: 1rem;
  border-radius: 4px;
  font-size: 1rem;
  letter-spacing: -0.8px;
  line-height: 1.5;
  overflow-wrap: break-word;
  font-weight: 700;
  padding: 0px 2rem;
  cursor: pointer;
  background: none rgb(255, 255, 255);
  display: flex;

  align-items: center;
  justify-content: center;
  text-align: center;
  min-height: 3.25rem;
  color: rgb(75, 40, 109);
  border: 0.0625rem solid rgb(75, 40, 109);
  transition: background 0.2s ease 0s, color 0.2s ease 0s, border 0.2s ease 0s;
`;
